import { Card, CardContent } from '@/components/ui/card'
import config from '../../../../../config'
import { useTranslation } from '@/hooks/useTranslation'

export const WebflowSection = () => {
	const { t } = useTranslation()
	
	return (
		<section id="webflow" className="mb-16">
			<h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6">
				{t('docs.webflow.title')}
			</h2>
			<Card className="shadow-sm dark:bg-gray-800/50">
				<CardContent className="pt-6">
					<ol className="list-decimal pl-5 space-y-3 text-gray-700 dark:text-gray-300">
						<li>{t('docs.webflow.step1')}</li>
						<li>{t('docs.webflow.step2')}</li>
						<li>
							{t('docs.webflow.step3.prefix')}{' '}
							<strong>{t('docs.webflow.step3.tabName')}</strong>{' '}
							{t('docs.webflow.step3.suffix')}
						</li>
						<li>
							{t('docs.webflow.step4.prefix')}{' '}
							<strong>{t('docs.webflow.step4.sectionName')}</strong>{' '}
							{t('docs.webflow.step4.suffix')}
						</li>
						<li>
							{t('docs.webflow.step5.prefix')}{' '}
							{config.appName}{' '}
							{t('docs.webflow.step5.suffix')}
						</li>
						<li>
							{t('docs.webflow.step6.prefix')}{' '}
							<strong>{t('docs.webflow.step6.button')}</strong>
						</li>
						<li>{t('docs.webflow.step7')}</li>
					</ol>
					<div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-md">
						<p className="text-sm text-blue-800 dark:text-blue-200">
							<strong>{t('docs.webflow.note.label')}</strong>{' '}
							{t('docs.webflow.note.text')}
						</p>
					</div>
				</CardContent>
			</Card>
		</section>
	)
}